// src/components/Footer.tsx
import React, { useState } from 'react';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  return (
    <footer className="bg-[#FAA61A] relative text-white">
      {/* Input za email - centriran i izbačen iznad footera */}
      <div className="container absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#2E2E2E] rounded-lg text-white p-4 mt-10 h-40 flex flex-col md:flex-row gap-[5%] flex-col w-[calc(100%-30px)] items-center">
        <div className='w-full md:w-[35%] flex align-center'>
          <div className='flex flex-row sm:flex-col flex-row align-start justify-center text-start pl-4 md:pl-10 mb-3 md:mb-0 stay-in-touch'>
            <h3 className="text-md md:text-3xl font-bold flex flex-row mr-1" style={{ width: 'fit-content', textWrap: 'nowrap'}}>Stay in Touch.</h3>
            <p className="text-md" style={{ width: 'fit-content' }}>Subscribe to be notified for ZEUS news!</p>
          </div>
        </div>
        <div className="flex items-center bg-white rounded-full overflow-hidden w-[calc(100%-20px)] md:w-[60%] h-[40px] md:h-[50px] mx-auto md:mr-5">
          <input
            type="email"
            placeholder="Email address"
            className="mx-4 py-2 w-full focus:outline-none text-gray-700 cursor-pointer"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="bg-[#FAA61A] text-white font-semibold px-4 py-2 rounded-full hover:bg-blue-800 h-full">
            Subscribe
          </button>
        </div>
      </div>

      {/* Sadržaj footera */}
      <div className="container mx-auto flex flex-wrap justify-start pt-20 pb-8 px-4 md:px-0 mt-16 w-full">
        <div className="basis-1/2 lg:basis-1/4 px-4 mb-8">
          <div className='w-[fit-content] flex flex-col mx-auto'>
            <h3 className="text-lg font-semibold mb-4 text-white">CONTACT</h3>
            <ul className="text-white whitespace-nowrap">
              <li>Partner</li>
              <li>Customer Support</li>
              <li>Submit a Request</li>
              <li>Support Center</li>
            </ul>
          </div>
        </div>
        <div className="basis-1/2 lg:basis-1/4 px-4 mb-8">
          <div className='w-[fit-content] flex flex-col mx-auto'>
            <h3 className="text-lg font-semibold mb-4 text-white">ABOUT ZEUS</h3>
            <ul className="text-white whitespace-nowrap">
              <li>Company</li>
              <li>Founder Q & A</li>
              <li>Careers</li>
              <li>Customer Reviews</li>
            </ul>
          </div>
        </div>
        <div className="basis-1/2 lg:basis-1/4 px-4 mb-8">
          <div className='w-[fit-content] flex flex-col mx-auto'>
            <h3 className="text-lg font-semibold mb-4 text-white">ABOUT ZEUS</h3>
            <ul className="text-white whitespace-nowrap">
              <li>Company</li>
              <li>Founder Q & A</li>
              <li>Careers</li>
              <li>Customer Reviews</li>
            </ul>
          </div>
        </div>
        <div className="basis-1/2 lg:basis-1/4 px-4 mb-8">
          <div className='w-[fit-content] flex flex-col mx-auto'>
            <h3 className="text-lg font-semibold mb-4 text-white">ABOUT ZEUS</h3>
            <ul className="text-white whitespace-nowrap">
              <li>Company</li>
              <li>Founder Q & A</li>
              <li>Careers</li>
              <li>Customer Reviews</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright tekst */}
      <div className="text-center pb-8">
        <p>ZEUS © 2025. Sva prava zadržana. - sitExpert.com</p>
      </div>
    </footer>
  );
};

export default Footer;